import {IReduxAppState} from '@src/@interfaces';

const state: IReduxAppState = {
    booting: false,
    booted: false,
    loading: false,
    loaded: false,
    fatalError: undefined,
    workSchedule: {
        timezoneOffsetInSeconds: 0,
        default: {},
        specific: {},
    }
};

export default state;
